import { Divider as AntDivider } from "antd";

const Divider = AntDivider;

export default Divider;
